<template>
    <div class="info-section">
        <div class="decor"></div>
        <div class="grid-decor-one">
            <div></div>
            <div></div>
            <div></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div></div>
            <div class="fill"></div>
            <div></div>
            <div></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div class="fill"></div>
        </div>
        <div class="grid-decor-two">
            <div class="fill"></div>
            <div></div>
            <div class="fill"></div>
            <div></div>
            <div></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div></div>
            <div></div>
        </div>
        <div class="decor-wrapper">
            <div class="decor one"></div>
            <div class="decor two"></div>
            <div class="decor three"></div>
        </div>
        <div class="slider-wrapper">
            <div class="slide">
                <div class="title">
                    <span class="company-title">{{ headline }}</span>
                     {{ this.firstText }} <span v-if="environment !== env_flower">IoT</span> {{ this.secondText }}
                </div>
                <div class="slide-description">
                    {{ this.thirdText }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoSection',
    data() {
        return {
            env_emeta: process.env.VUE_APP_ENV_EMETA,
            env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
            env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
            env_flower: process.env.VUE_APP_ENV_FLOWER,
            environment: process.env.VUE_APP_ENVIRONMENT,
            headline: process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER ? 'Flower Your Place' : 'Tentacles IoT',
        };
    },
    computed: {
      firstText() {
        if (process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER) {
          return this.$t('login.first_flower');
        }
        return this.$t('login.first');
      },
      secondText() {
        if (process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER) {
          return this.$t('login.second_flower');
        }
        return this.$t('login.second');
      },
      thirdText() {
        if (process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER) {
          return this.$t('login.third_flower');
        }
        return this.$t('login.third');
      },
    },
    methods: {
      showInEnv(type) {
        if (Array.isArray(type)) {
          return type.includes(process.env.VUE_APP_ENVIRONMENT);
        }
        return process.env.VUE_APP_ENVIRONMENT === type;
      },
    },
};
</script>

<style lang="scss">
    .info-section {
        flex: 1;
        background-color: $company-color-login;
        background-image: linear-gradient(90deg,
                $company-color-login, $company-color-login);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        @media only screen and (max-width: 1500px) {
            max-width: 0;
        }

        .decor {
            width: 50rem;
            height: 40rem;
            position: absolute;
            top: -25rem;
            right: 0;
            transform: rotate(30deg);
            background-color:
                    transparent;
            background-image: linear-gradient(90deg,
                    transparent, rgba(255, 255, 255, 0.1));

        }
        .grid-decor-one {
            position: absolute;
            bottom: 0;
            right: 12rem;
            display: grid;
            grid-template-columns: 3.5rem 3.5rem 3.5rem 3.5rem;
            grid-template-rows: 3.5rem 3.5rem 3.5rem;
            .fill {
                background-color: white;
            }
        }
        .grid-decor-two {
            position: absolute;
            top: 0;
            left: 12rem;
            display: grid;
            grid-template-columns: 3.5rem 3.5rem 3.5rem 3.5rem;
            grid-template-rows: 3.5rem 3.5rem 3.5rem;
            .fill {
                background-color: #122404;
            }
        }
        .decor-wrapper {
            position: absolute;
            width: 46rem;
            min-height: 35rem;
            display: flex;
            align-items: center;
            .decor {
                width: 20rem;
                height: 40rem;
                border-radius: 6rem;
                background-color:
                        transparent;
                background-image: linear-gradient(90deg,
                        transparent,
                        rgba(255, 255, 255, 0.1));
                margin-right: 1rem;
                position: absolute;
                top: 4em;
                left: 8em;
            }
            .one {
                transform: rotate(15deg) translate(-9em, 2em) !important;
            }
            .two {
                transform: rotate(15deg);
            }
            .three {
                transform: rotate(15deg) translate(9em, -2em) !important;
            }
        }
        .slider-wrapper {
            width: 64rem;
            height: 28rem;
            .slide {
                width: 100%;
                height: 100%;
                .title {
                    font-size: 6rem;
                    color: white;
                    font-weight: 700;
                    margin-bottom: 0.4em;
                    span {
                        color: $company-color-title-key !important;
                    }
                    .company-title {
                        display: block;
                        margin-bottom: 0.35em;
                        color: $company-color-title !important;
                    }
                }
                .slide-description {
                    font-size: 1.4rem;
                    font-weight: 400;
                    color: white;
                    line-height: 2.4rem;
                }
            }
        }
    }
</style>
